







































































































































































































import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { APICarrier } from '../../models/api/carrier.model'
import { APIProvider } from '../../models/api/provider.model'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class UsersForm extends Vue {
    loading = true;
    cardTitle = '';
    providerLoading = false;
    carrierLoading = false;
    buttonLoading = false;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: { [key: string]: any } = {
        password: '',
        carrierId: {
            carrierId: 0
        },
        providerId: {
            providerId: 0
        }
    };

    formValid = false;
    formRules = {
        name: [
            (v: string) => !!v || 'Name is required',
            (v: string) =>
                (v && v.length <= 64) || 'Name must be less than 64 characters',
            (v: string) =>
                (v && v.length >= 1) || 'Name must be at least 1 characters'
        ],
        password: [
            (v: string) => !!v || 'Password is required',
            (v: string) =>
                (v && v.length <= 128) ||
                'Field must be less than 128 characters',
            (v: string) =>
                (v && v.length >= 8) || 'Field must at least 8 characters'
        ],
        email: [
            (v: string) => !!v || 'Email is required',
            (v: string) => {
                if (v) {
                    return (
                        v.length <= 64 ||
                        'Field must be less than 50 characters'
                    )
                } else {
                    return true
                }
            },
            (v: string) => {
                if (v) {
                    return v.length >= 5 || 'Field must at least 5 characters'
                } else {
                    return true
                }
            },
            (v: string) => {
                if (v) {
                    const pattern = /^\w+([.-]?\w+)*(\+\w+)?@\w+([.-]?\w+)*(\.\w{2,})+$/
                    return pattern.test(v) || 'Email entered is not valid'
                } else {
                    return true
                }
            }
        ],
        required: [(v: string) => !!v || 'This Field is required'],
        phone: [
            (v: string) => {
                if (v) {
                    return (
                        v.length <= 50 ||
                        'Field must be less than 50 characters'
                    )
                } else {
                    return true
                }
            }
        ]
    };

    formModel: { carriers: APICarrier[]; providers: APIProvider[] } = {
        carriers: [],
        providers: []
    };

    @Watch('formData.carrierId')
    async onCarrierChange () {
        if (this?.formModel?.providers?.length && this?.formData?.carrierId !== null && this?.formData?.providerId !== null) {
            this.formData.providerId = null
        }
        this.formModel.providers = []
        if (this.formData.carrierId) {
            await this.getProviders()
        }
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', {
                code: 1000,
                message: 'Error, not action sended in route params :('
            })
            return
        }

        this.loading = true

        await this.getCarriers()

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit User'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create User'
            this.formData = {
                password: '',
                carrierId: 0,
                providerId: 0
            }
            this.loading = false
            break
        }
    }

    async getCarriers () {
        try {
            this.carrierLoading = true
            const { status } = await this.$store.dispatch('getCarriers')
            if (status !== 200) return
            this.formModel.carriers = this.$store.state?.CarriersStore?.carriers?.map(
                (c: APICarrier) => {
                    return {
                        text: c.carrierName,
                        value: c.carrierId
                    }
                }
            )

            if (this.formModel.carriers.length === 1) {
                this.formData.carrierId = (this.formModel // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    .carriers[0] as any).values
            }
        } finally {
            this.carrierLoading = false
        }
    }

    async getProviders () {
        this.providerLoading = true
        try {
            const { status, data } = await this.$store.dispatch(
                'getMonitorProvidersList',
                this.formData.carrierId
            )
            if (status !== 200) return
            this.formModel.providers = data.map((p: APIProvider) => {
                return {
                    text: p.providerName,
                    value: p.providerId
                }
            })
        } finally {
            this.providerLoading = false
        }
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', {
                code: 1000,
                message: 'Error, not id sended in route params :('
            })
            this.loading = false
            return
        }
        this.$store
            .dispatch('getUserById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.UsersStore.userForm

                    if (!this.formData.carrierId) {
                        this.formData.carrierId = null
                    } else {
                        this.formData.carrierId = this.formData.carrierId?.carrierId
                    }

                    if (!this.formData.providerId) {
                        this.formData.providerId = null
                    } else {
                        this.formData.providerId = this.formData.providerId?.providerId
                    }
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        if (!this.formData.providerId) {
            this.formData.providerId = null
        }

        if (!this.formData.carrierId) {
            this.formData.carrierId = null
        }

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editUser', this.formData).then(resp => {
                this.buttonLoading = false
                if (resp?.status === 200) {
                    this.$store.commit(
                        'reportSuccess',
                        'Done Successfully!'
                    )
                    this.$router
                        .push({
                            name: 'Users'
                        })
                        .then(() => {
                            this.buttonLoading = false
                        })
                }
            })
            break
        case 'add':
            this.$store.dispatch('createUser', this.formData).then(resp => {
                this.buttonLoading = false
                if (resp?.status === 200) {
                    this.$store.commit(
                        'reportSuccess',
                        'Done Successfully!'
                    )
                    this.$router
                        .push({
                            name: 'Users'
                        })
                        .then(() => {
                            this.buttonLoading = false
                        })
                }
            })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date
            .getDate()
            .toString()
            .padStart(2, '0')
        const month = date
            .getMonth()
            .toString()
            .padStart(2, '0')
        const year = date
            .getFullYear()
            .toString()
            .padStart(4, '0')
        const hours = date
            .getHours()
            .toString()
            .padStart(2, '0')
        const minutes = date
            .getMinutes()
            .toString()
            .padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
